var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".intro[data-v-3cd78ccf]{background-image:url(" + escape(require("../assets/images/temp/intro-image-2.png")) + ")}ul[data-v-3cd78ccf]{margin-left:2.5em}", ""]);

// exports
